import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { FiStar } from "react-icons/fi";
import { useCookies } from "react-cookie";
import $ from "jquery";

import HeaderSearchBar from "../components/headerSearchBar";

import "../css/livros.css"

export default function Livros() {

    const [cookies, setCookie, removeCookie] = useCookies(["userPuuId"]);

    var userId = cookies.userPuuId;

    let { id } = useParams();

    const [ bookTitle, setBookTitle ] = useState("");
    const [ bookAuthor, setBookAuthor ] = useState("");
    const [ bookDescription, setDescription ] = useState("");
    const [ bookPublisher, setBookPublisher ] = useState("");
    const [ bookPubliDate, setBookPubliDate ] = useState("");

    const [ bookReadingPages, setReadingPages ] = useState("");
    const [ bookPrintedPages, sertPrintedPages ] = useState("");

    const [ bookRating, setBookRating ] = useState("");

    const [ bookPrice, setBookPrice ] = useState("");

    const [ libraryId, setLibId ] = useState("");

    function bookBuyingPage() {
        axios.get(`https://www.googleapis.com/books/v1/volumes/${id}`)
        .then(resp => {
            var data = resp.data;
            var volumeInfo = data.volumeInfo;
            window.open(data.saleInfo.buyLink);
        })
    }

    useEffect(() => {

        axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${userId}`)
        .then(resp => {
            var data = resp.data.userInfo;
            
            if(data.libraryId) {
                setLibId(data.libraryId);
            }

        })

        if(userId) {
            axios.get(`https://cloudify-backend.herokuapp.com/functions/history/add/${id}/${userId}`)
        }
        else return false;

        axios.get(`https://www.googleapis.com/books/v1/volumes/${id}`)
        .then(resp => {
            var data = resp.data;
            var volumeInfo = data.volumeInfo;
            var saleInfo = data.saleInfo;
            document.getElementById("moreInfo").href = data.accessInfo.webReaderLink;

            if(volumeInfo.readingModes.image == true) {
                document.getElementById("illustOn").hidden = false;
            }

            volumeInfo.categories.forEach(category => {
                $("#categoryList").append(`<li> ${category} </li>`)
            });

            var desc = volumeInfo.description;
            if(desc) {
                desc.replace("<p>", "");
                desc.replace("</p>", "");
            }
            else {
                desc = "Sem descrição";
            }

            setBookTitle(volumeInfo.title);
            setBookAuthor(volumeInfo.authors.join(', '));
            setBookPublisher(volumeInfo.publisher);
            setBookPubliDate(volumeInfo.publishedDate);
            setDescription(volumeInfo.description);

            setReadingPages(volumeInfo.pageCount);
            sertPrintedPages(volumeInfo.printedPageCount);

            if(volumeInfo.previewLink) {
                document.getElementById("bookPreview").href = volumeInfo.previewLink;
            }
            else {
                document.getElementById("readPreview").disabled = true;
            }

            if(volumeInfo.imageLinks) {
                if (volumeInfo.imageLinks.extraLarge) {
                    document.getElementById("bookFront").src = volumeInfo.imageLinks.extraLarge;
                }
                if (volumeInfo.imageLinks.large) {
                    document.getElementById("bookFront").src = volumeInfo.imageLinks.large;
                }
                if (volumeInfo.imageLinks.thumbnail) {
                    document.getElementById("bookFront").src = volumeInfo.imageLinks.thumbnail;
                }
            }
            else {
                document.getElementById("bookFront").src = "https://i.ibb.co/S5yfWXR/unkw-book.png"
            }

            if(volumeInfo.averageRating) {
                setBookRating(volumeInfo.averageRating);
            }
            else {
                setBookRating(0);
            }

            if(saleInfo.saleability == "FOR_SALE") {
                setBookPrice(`R$ ${data.saleInfo.listPrice.amount}`);
            }
            else {
                setBookPrice("GRATUITO")
            }

            if(data.accessInfo.pdf.isAvailable == true) { document.getElementById("pdfDisp").hidden = false; } 
            if(data.accessInfo.epub.isAvailable == true) { document.getElementById("epubDisp").hidden = false; }
        })

        console.log(`Libid: ${libraryId}`)

        if(libraryId != "") {
            document.getElementById("libraryAdd").hidden = false;
            axios.get(`https://cloudify-backend.herokuapp.com/libraries/details/${libraryId}`)
            .then(resp => {
                console.log(resp.data);
            })
        }
        else document.getElementById("libraryAdd").hidden = false;
    }, [])

    function addToLib() {
        axios.post(`https://cloudify-backend.herokuapp.com/libraries/books/add/${libraryId}`, {
            bookId: id
        })
        .then(resp => {
            console.log(resp.data)
            window.location.reload();
        })
    }

    return (
        <div className="app">
            <HeaderSearchBar />

            <div id="bookShowingDiv">
                <div id="readingOptions">
                    <img id="bookFront" />

                    <div className="readingElements">

                        <div className="centered">
                            <button id="buyButton" onClick={() => { document.getElementById("sellingDiv").scrollIntoView(); }} >Informações de compra</button>
                        </div>

                        <h3 id="illustOn" hidden>Possui ilustrações</h3>
                        <h3>{bookReadingPages} páginas de leitura</h3>
                        <h3>{bookPrintedPages} páginas totais</h3>

                        <div id="categoryDiv">
                            <ul id="categoryList" />
                        </div>

                        <div id="bookingRateDiv">
                            <FiStar />
                            <h3>{bookRating}</h3>
                        </div>

                        <div id="disponibleIn">
                            <h3>Disponível em:</h3>
                            <ul id="dispIn">
                                <li id="epubDisp" hidden>ePub</li>
                                <li id="pdfDisp" hidden>PDF</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div id="bookInfoDisplayer">
                    <h1>{bookTitle}</h1>

                    <button id="libraryAdd" onClick={addToLib} hidden >Adicionar à bilioteca</button>

                    <h3 id="bookInfoText">Autores: {bookAuthor}</h3>
                    <h3 id="bookInfoText">Publicado por {bookPublisher} em: {bookPubliDate}</h3>
                    
                    <div className="descriptionDiv">
                        <h3>Descrição</h3>
                        <p id="bookDesc">{bookDescription}</p>
                    </div>

                    <div id="sellingDiv">
                        <h3>Onde comprar</h3>

                        <h4 id="googleFromInfos">INFORMAÇÕES RETIRADAS DO GOOGLE BOOKS</h4>

                        <h2>Compre agora por {bookPrice} em:</h2>

                        <a id="bookBuyButton">
                            <button id="googleBooksBuyingButton" onClick={bookBuyingPage} type="button" >
                                <img src="https://img.icons8.com/color/452/google-books.png" />
                                <h3>Comprar no Google Livros</h3>
                            </button>
                        </a>
                        
                        <div id="buttonSellingInfo">
                            <a id="bookPreview"> <button id="readPreview" >Ler prévia</button> </a>
                        </div>

                        <div id="priceAndInfo">
                            <a id="moreInfo">Mais informações</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}